import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "isOpened", "onTransitionEnd"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ResizeObserver from 'resize-observer-polyfill';
import { jsx as _jsx } from "react/jsx-runtime";
export var Container = styled.div.withConfig({
  componentId: "sc-c810pe-0"
})(["max-height:", ";overflow:hidden;transition:max-height 200ms ease-in;"], function (_ref2) {
  var isOpened = _ref2.isOpened,
    maxHeight = _ref2.maxHeight;
  if (isOpened && maxHeight) return "".concat(maxHeight, "px");
  if (isOpened) return '100vh';
  return 0;
});
export var Content = styled.div.withConfig({
  componentId: "sc-c810pe-1"
})(["overflow:auto;"]);
var Collapse = function Collapse(_ref) {
  var children = _ref.children,
    isOpened = _ref.isOpened,
    onTransitionEnd = _ref.onTransitionEnd,
    rest = _objectWithoutProperties(_ref, _excluded);
  var containerRef = useRef();
  var contentRef = useRef();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    maxHeight = _useState2[0],
    setMaxHeight = _useState2[1];
  var updateMaxHeight = useCallback(function () {
    if (contentRef.current) {
      var offsetHeight = contentRef.current.offsetHeight;
      setMaxHeight(offsetHeight);
    }
  }, []);
  var handleTransitionEnd = useCallback(function (event) {
    onTransitionEnd({
      event: event,
      isOpened: isOpened
    });
  }, [onTransitionEnd, isOpened]);
  useEffect(function () {
    var containerEle = containerRef.current;
    containerEle.addEventListener('transitionend', handleTransitionEnd);
    return function () {
      containerEle.removeEventListener('transitionend', handleTransitionEnd);
    };
  }, [handleTransitionEnd]);
  useEffect(function () {
    var contentEle = contentRef.current;
    var animationFrameID;
    var resizeObserver = new ResizeObserver(function () {
      animationFrameID = window.requestAnimationFrame(function () {
        return updateMaxHeight();
      });
    });
    resizeObserver.observe(contentEle);
    updateMaxHeight();
    return function () {
      resizeObserver.unobserve(contentEle);
      if (animationFrameID !== null) {
        window.cancelAnimationFrame(animationFrameID);
      }
    };
  }, [updateMaxHeight]);
  return /*#__PURE__*/_jsx(Container, _objectSpread(_objectSpread({
    isOpened: isOpened,
    maxHeight: maxHeight,
    ref: containerRef,
    "aria-hidden": !isOpened
  }, rest), {}, {
    children: /*#__PURE__*/_jsx(Content, {
      ref: contentRef,
      children: children
    })
  }));
};
Collapse.displayName = 'Collapse';
Collapse.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  isOpened: PropTypes.bool.isRequired,
  onTransitionEnd: PropTypes.func
};
Collapse.defaultProps = {
  onTransitionEnd: function onTransitionEnd() {}
};
export default Collapse;